import React from 'react';

function Footer() {
    return (
        <footer>
            <p>© Copyright <strong>Valorant Infos</strong>. All Rights Reserved</p>
            <p>Valorant Infos est un fan site non officielle et n'est en aucun cas approuvée par Riot Games.</p>
            <p>Riot Games, Valorant et toutes les propriétés associées sont des marques commerciales ou des marques déposées de Riot Games, Inc.</p>
        </footer>
    )
}

export default Footer;